import type { AeEvaluatedQuestion } from '@/types/assessmentEngine';

/** Resolve UI index after save — never jump to question 1 when lookup misses. */
export function resolveNextQuestionIndex(
  ordered: AeEvaluatedQuestion[],
  flat: AeEvaluatedQuestion[],
  nextKey: string,
  currentKey: string,
  currentIndex: number
): number {
  const inOrdered = ordered.findIndex((q) => q.question_key === nextKey);
  if (inOrdered >= 0) return inOrdered;

  const inFlat = flat.findIndex((q) => q.question_key === nextKey);
  if (inFlat >= 0) return inFlat;

  const curInOrdered = ordered.findIndex((q) => q.question_key === currentKey);
  if (curInOrdered >= 0 && curInOrdered + 1 < ordered.length) {
    return curInOrdered + 1;
  }

  if (currentIndex + 1 < ordered.length) return currentIndex + 1;
  return Math.max(0, ordered.length - 1);
}
